<template>
  <div>
    <div v-for="(product, product_index) in product_detail" :key="_uid+'services-popular'+product_index">
      <section class="section services-popular"
               v-if="statics_detail[product.baseProdotto.pid].schedaProdotto.caratteristiche_prodotto.known.i_piu_amati"
      >
        <accordion-block
          title="I servizi più amati"
          :collapse_id="'accordion-services-popular-'+_uid+'-'+product_index"
        >
          <b-row>
            <b-col lg="3"
                   v-for="(popular, popular_index) in statics_detail[product.baseProdotto.pid].schedaProdotto.caratteristiche_prodotto.known.i_piu_amati"
                   v-bind:key="_uid+popular_index">

              <vb-card :card="{
                title: popular.nome,
                text: popular.note_caratteristica,
              }" />

            </b-col>
          </b-row>
        </accordion-block>
      </section>
    </div>
  </div>
</template>

<script>
import Card from '@library/blocks/card'
import AccordionBlock from './accordion-block.vue'

export default {
  name: 'services-popular',

  props: {
    statics_detail: Object,
    product_detail: Array,
  },

  components: {
    'vb-card': Card,
    'accordion-block': AccordionBlock,
  },

  data() {
    return {
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .services-popular {
    @extend %section_margin;

    @include media-breakpoint-up(md) {
      padding-top: $grid-gutter-20*3;
    }

    &.section {
      margin-bottom: 0;
    }
  }

</style>